import React, { useState, useEffect } from "react"
import ReactDom from "react-dom"
import { MdClose } from "react-icons/md"
import { useLocation, useHistory } from "react-router-dom"
import { parse, stringify } from "query-string"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./SidebarModal.module.scss"

const SidebarModal = props => {
  const {
    urlQuery,
    urlQueryValue,
    children,
    open = false,
    title = "",
    onEnter = () => { },
    onClose = () => { },
    onExited = () => { }
  } = props

  const i18n = useTranslation()[1]

  const history = useHistory()

  const location = useLocation()

  const query = parse(location.search)

  const [mount, setMount] = useState(false)

  const removeQueryToUrl = () => {
    if (!urlQuery) return
    if (!urlQueryValue) return

    const newQuery = { ...query }

    delete newQuery[urlQuery]

    const q = stringify(newQuery)

    history.push(`${location.pathname}?${q}`, { replace: true })
  }

  const closeSidebarOnGoBack = () => {
    const flag =
      !mount ||
      !urlQuery ||
      !urlQueryValue ||
      !!query[urlQuery]

    if (flag) return

    const newQuery = { ...query }

    delete newQuery[urlQuery]

    const q = stringify(newQuery)

    history.push(`${location.pathname}?${q}`, { replace: true })

    onClose()
  }

  const addQueryToUrl = () => {
    if (!urlQuery) return
    if (!urlQueryValue) return
    if (!open) return

    const newQuery = { ...query }

    newQuery[urlQuery] = urlQueryValue

    const q = stringify(newQuery)

    history.push(`${location.pathname}?${q}`)
  }

  const handleAnimationEnd = e => {
    e.stopPropagation()

    if (!open) {
      setMount(false)

      onExited()
    }
  }

  useEffect(() => {
    if (!open && mount) {
      return removeQueryToUrl()
    }

    addQueryToUrl()

    open && onEnter()

    setMount(open)
  }, [open])

  useEffect(() => {
    closeSidebarOnGoBack()
  }, [query[urlQuery]])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return mount
    ?
    ReactDom.createPortal(
      <div
        onAnimationEnd={handleAnimationEnd}
        className={clsx(
          classes["modal"],
          isLtr && classes["modal-ltr"],
          !open && classes["fade-out"]
        )}
      >
        <div
          className={classes["overlayer"]}
          onClick={() => onClose()}
        />

        <div
          className={clsx(
            classes["sidebar"],
            isLtr && classes["sidebar-ltr"],
            !open && classes["sidebar-hide"],
            !open && isLtr && classes["sidebar-hide-ltr"]
          )}
        >
          <div className={classes["sidebar-header"]}>
            <b className={classes["header"]}>
              {title}
            </b>
            <MdClose
              size={20}
              className={classes["close"]}
              onClick={onClose}
            />
          </div>

          <div className={classes["sidebar-contents"]}>
            {children}
          </div>
        </div>
      </div>
      ,
      document.body
    )
    :
    null
}

export default SidebarModal